import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class SaltChlorinator extends AlertLogic {
    static type = AlertType.SaltChlorinator;
    static category = AlertCategories.WATER_QUIALITY;
    static contentCategories = [ ContentCategories.WATER_QUALITY ];
    static title = Locale.gettext('Salt Chlorinator Issue');

    getInfo(alert:AlertRecord = this.alert, config:Config.AllConfig = this.allConfigs):AlertInfo {
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(alert, config);
        
        // Varying across alert types
        const errors = [];
        if (alertData?.ErrorStates) {
            Object
            .entries(alertData.ErrorStates)
            .forEach(([ key, val ]) => {
                switch (key) {
                    case "LOW_SALT": errors.push(
                        this.locale.gettext("The device is reporting: Low Salt.\nFirst reported at: %s", this.locale.formatDateTime(new Date(val as string)))
                    ); break;
                    case "INSPECT_CELL": errors.push(
                        this.locale.gettext("The device is reporting: Inspect Cell.\nFirst reported at: %s", this.locale.formatDateTime(new Date(val as string)))
                    ); break;
                    case "HIGH_SALT": errors.push(
                        this.locale.gettext("The device is reporting: High Salt.\nFirst reported at: %s", this.locale.formatDateTime(new Date(val as string)))
                    ); break;
                    case "POWER_OUT": errors.push(
                        this.locale.gettext("The device is reporting: Power Out.\nFirst reported at: %s", this.locale.formatDateTime(new Date(val as string)))
                    ); break;
                    case "NO_FLOW_WHILE_GENERATING": errors.push(
                        this.locale.gettext("The device is reporting: No Flow While Generating.\nFirst reported at: %s", this.locale.formatDateTime(new Date(val as string)))
                    ); break;
                    case "VERY_LOW_SALT": errors.push(
                        this.locale.gettext("The device is reporting: Very Low Salt Levels.\nFirst reported at: %s", this.locale.formatDateTime(new Date(val as string)))
                    ); break;
                    case "COLD_WATER": errors.push(
                        this.locale.gettext("The device is reporting: Cold Water.\nFirst reported at: %s", this.locale.formatDateTime(new Date(val as string)))
                    ); break;
                    default: 
                        errors.push(
                            this.locale.gettext("The device is reporting: %s.\nFirst reported at: %s", key, this.locale.formatDateTime(new Date(val as string)))
                        ); break;
                    }
            });
        }

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Salt Chlorinator Issue'),
            cardDescription: this.locale.gettext('%1$s is reporting an issue.', device.Name),
            cardIllustration: 'pipes_emergency',
            detailIcon: 'salt-cell',
            detailDescription: this.locale.gettext('%1$s%2$s is reporting an issue.', 
                device.Name, 
                device.HardwareDevice?.UniqueBusIdentifier ?
                    ' (Serial port: ' + device.HardwareDevice?.Ports[0]?.Number + ', Bus ID : ' + device.HardwareDevice?.UniqueBusIdentifier + ')' :
                    ''
            ),
            detailDescriptionArr: errors,
            actionButtonTitle: '',
            resolveSummary: this.locale.gettext('%1$s error cleared', device.Name)
        });
        alertInfo.contentCategories = SaltChlorinator.contentCategories;
        return alertInfo;
    }

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord|AlertRecord[] {
        let device = config.Config.Devices.find(dev => dev.DeviceType === "SaltCell");
        
        return new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device.UUID,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type: type,
            data: {
                ErrorStates: [
                    "LOW_SALT", 'TOO_HIGH', "INSPECT_CELL", "HIGH_SALT", "POWER_OUT", "NO_FLOW_WHILE_GENERATING", "VERY_LOW_SALT", "COLD_WATER"
                ]
            }
        });
    }
}